import React from 'react';
import './contact-us.css';
import SendIcon from '../../../assets/images/Ic_send.png';
import ContactusEmailIcon from '../../../assets/images/contactusemail.png';
import ContactusPhoneIcon from '../../../assets/images/contactusphone.png';
import ContactusLocationIcon from '../../../assets/images/contactuslocation.png';
import ContactusChatIcon from '../../../assets/images/contactuschat.png';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { ClientPreLoginService } from '../../../services/clientPreLoginService';
const ContactUs = () => {
  const [errorMessage, setErrorMessage] = useState(sessionStorage.getItem('errorMessage') || '');

  const [formData, setFormData] = useState({
    name: "",
    emailId: "",
    mobileNo: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const validate = (name, value) => {
    let error = "";
    if (name === "name") {
      if (!/^[A-Za-z ]+$/.test(value)) error = "Name should contain only letters and spaces";
    }
    if (name === "mobileNo") {
      if (/^0/.test(value)) {
        error = "Mobile number should not start with 0";
      } else if (!/^\+?[0-9]{2}[0-9]{10}$/.test(value)) {
        error = "Enter a valid mobile number (+919876XXXXX0)";
      }
    }
    if (name === "emailId") {
      if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) error = "Enter a valid email address";
    }
    if (name === "message") {
      if (value.length > 150) error = "Message cannot exceed 150 characters";
    }
    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newValue = name === "mobileNo" ? value.replace(/^0+/, '') : value;
    if (name === "message" && value.length > 150) return;
    setFormData({ ...formData, [name]: newValue });
    setErrors({ ...errors, [name]: validate(name, newValue) });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let newErrors = {};
    Object.keys(formData).forEach((key) => {
      if (key !== "message" && !formData[key]) {
        newErrors[key] = "This field is required";
      } else {
        newErrors[key] = validate(key, formData[key]);
      }
    });
    setErrors(newErrors);
    if (Object.values(newErrors).every((err) => err === "")) {
      const requestBody = {
        name: formData.name,
        emailId: formData.emailId,
        mobileNo: formData.mobileNo,
        message: formData.message,
      };

      try {
        const response = await ClientPreLoginService.letsTalkContactForm(requestBody);
        if (response.status === 200) {
          setErrorMessage("Form submitted successfully!");
          setFormData({
            name: "",
            emailId: "",
            mobileNo: "",
            message: "",
          });
          setErrors({});
        } else {
          console.error("Failed response:", response);
          setErrorMessage("Failed to submit.");
        }
      } catch (error) {
        console.error("Contact request failed:", error);
        setErrorMessage("Failed to submit");
      }
    }
  };

  return (
    <div>
      <div className='fluid-container'>
        {errorMessage && (
          <div className="login-alert-overlay">
            <div className="login-alert-box">
              <div className="login-alert-content">
                <p>{errorMessage}</p>
                <button className="login-alert-button" onClick={() => setErrorMessage('')}>
                  OK
                </button>
              </div>
            </div>
          </div>
        )}
        <div className="contactus-heading-container">
          <div className='contact-us-breadcrumb'>
            <span style={{ color: '#FFFFFF', fontWeight: '600', textDecoration: 'none', marginRight: '50px' }}>
              <Link
                to={-1}
                style={{ color: '#FFFFFF', textDecoration: 'none' }}
                state={{ scrollPosition: location.state?.scrollPosition }}
              >
                Back
              </Link>
              <span style={{ marginLeft: '10px' }}> /</span>
              <span style={{ marginLeft: '10px' }}> Contact Us</span>
            </span>
          </div>
          <p className="contactus-heading">LET'S TALK!</p>
        </div>
        <div className='container'>
          <div className="contactus-container">
            <div className="contactus-info">
              <div className="contactus-info-item">
                <div className="contactus-icon-container">
                  <img src={ContactusEmailIcon} alt="Email Icon" />
                </div>
                <div className="contactus-text-container">
                  <p>Email Us</p>
                  <a href="mailto:sales@leaderly.in">sales@leaderly.in</a>
                </div>
              </div>
              <div className="contactus-info-item">
                <div className="contactus-icon-container">
                  <img src={ContactusPhoneIcon} alt="Phone Icon" />
                </div>
                <div className="contactus-text-container">
                  <p>Call Us</p>
                  <a href="tel:+917738333452">+91 7738333452</a>
                </div>
              </div>
              <div className="contactus-info-item">
                <div className="contactus-location-icon-container">
                  <img src={ContactusLocationIcon} alt="Location Icon" className="contactus-location-icon" />
                </div>
                <div className="contactus-text-container">
                  <p>Visit Us</p>
                  <a href="#">
                    Delhi, Mumbai, Bangalore
                  </a>
                </div>
              </div>

              {/* <div className="contactus-info-item">
                <div className="contactus-icon-container">
                  <img src={ContactusChatIcon} alt="Chat Icon" />
                </div>
                <div className="contactus-text-container">
                  <p>Live Chat With Us</p>
                  <a href="#">Lorem ipsum dolor sit amet, consectetur</a>
                </div>
              </div> */}
              {/* <div className="live-chat-button">
                <button className="live-chat-btn">Live Chat</button>
              </div> */}
            </div>
            <div className="contactus-form">
              <h2>Drop us a Line</h2>
              <form onSubmit={handleSubmit}>
                <input type="text" name="name" placeholder="Full Name *" value={formData.name} onChange={handleChange} spellCheck='false' />
                {errors.name && <p className="error">{errors.name}</p>}<br />

                <input type="text" name="mobileNo" placeholder="Mobile Number*" value={formData.mobileNo} onChange={handleChange} spellCheck='false' />
                {errors.mobileNo && <p className="error">{errors.mobileNo}</p>}<br />

                <input type="email" name="emailId" placeholder="Email Address *" value={formData.emailId} onChange={handleChange} spellCheck='false' />
                {errors.emailId && <p className="error">{errors.emailId}</p>}<br />

                <textarea name="message" placeholder="Message (Optional)" value={formData.message} onChange={handleChange} spellCheck='false'></textarea>
                {errors.message && <p className="error">{errors.message}</p>}<br />

                <a href="#" className="send-message" onClick={handleSubmit}>
                  <span className="send-message-text">Send A Message</span>
                  <span className="send-message-arrow">
                    <img src={SendIcon} alt="sendicon" className="send-icon-image" />
                  </span>
                </a>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;